import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

export const ENTITY_DETAILS_APPS_DOC = 'entityDetailsApps';
export const CURRENT_VERSION = 'v1';

// EntityDetails.ClientTab is a superset of EntityDetails.PersistedTab.
// This can cause typescript to not warn us about writing
// the client version into firestore
// This transformer handles that case
const clientTabToPersisted = (
  tab: EntityDetails.ClientTab | EntityDetails.PersistedTab,
): EntityDetails.PersistedTab => {
  return {
    type: tab.type,
    typeId: tab.typeId,
    // A cleared label is undefined; withoutNulls strips it before the write.
    label: tab.label,
  };
};

export const entityDetailsAppSateConverter = {
  toFirestore(app: EntityDetails.App): firebase.firestore.DocumentData {
    return withoutNulls({ ...app, tabs: app.tabs.map(clientTabToPersisted) });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): EntityDetails.App {
    const data = {
      ...snapshot.data(options),
    };
    return data as EntityDetails.App;
  },
};

const getEntityDetailsApps = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.CONTENT_DISTRIBUTIONS_COLLECTION)
    .doc(ENTITY_DETAILS_APPS_DOC)
    .collection(CURRENT_VERSION)
    .withConverter(entityDetailsAppSateConverter);
};

export default getEntityDetailsApps;
